"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLModule = void 0;
const base_1 = require("./base");
class HTMLModule extends base_1.LabeledModule {
    constructor() {
        super(...arguments);
        this._type = "Html";
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const builderConfigModule = {
                id: this.id,
                label: this.label,
                style: this.style,
                type: this.type,
            };
            if (this.tag) {
                builderConfigModule.tag = this.tag;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        const { label, ...rest } = this.toBuilderConfig();
        return {
            ...rest,
            content: label[this.languageCode],
            actionRequired: this.actionRequired,
        };
    }
    editProps() {
        return undefined;
    }
}
exports.HTMLModule = HTMLModule;
//# sourceMappingURL=Html.js.map